import React, { Component } from 'react';
import { Form, Input, message, Modal, Radio, TreeSelect } from 'antd';

import { queryAllCompany, queryCompany } from '@api/core/org';
import { queryFundsBookInfo } from '@api/finance/funds';

const RadioGroup = Radio.Group;

const FormItem = Form.Item;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
      treeData: [],
    };
  }

  componentDidMount() {
    const { uuid } = this.props;
    this.loadCompany();
    if (uuid) {
      this.loadDetail(uuid);
    }
  }

  /**
   *获取组织列表
   */
  loadCompany = () => {
    const params = {};
    queryAllCompany(params).then(res => {
      if (res.statusCode === 200) {
        const options = [];
        res.data.map(item => {
          const optionItem = {};
          optionItem.label = item.name;
          optionItem.value = item.uuid;
          optionItem.key = item.uuid;
          options.push(optionItem);
          return options;
        });
        this.setState({
          treeData: options,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  onLoadData = treeNode => {
    const arr = [];
    const key = treeNode.props.eventKey;
    const params = {};
    params.type = 1;
    params.uuid = key.split('-')[key.split('-').length - 1];
    return new Promise(resolve => {
      queryCompany(params).then(res => {
        if (res.statusCode === 200) {
          res.data.map(item => {
            const optionItem = {};
            optionItem.label = item.name;
            optionItem.value = item.uuid;
            optionItem.key = `${key}-${item.uuid}`;
            arr.push(optionItem);
            return arr;
          });
          const treeData = [...this.state.treeData];
          const loop = data => {
            data.forEach(item => {
              if (key.indexOf(item.key) === 0) {
                if (item.children) {
                  resolve();
                  loop(item.children);
                } else if (item.key === key) {
                  if (arr.length > 0) {
                    item.children = arr;
                    this.setState({ treeData }, () => {
                      resolve();
                    });
                  } else if (arr.length === 0) {
                    item.isLeaf = true;
                    this.setState({ treeData }, () => {
                      resolve();
                    });
                  } else {
                    resolve();
                  }
                }
              }
            });
          };
          loop(treeData);
        }
      });
    });
  };

  handleCompany = (e, option) => {
    this.companyName = option[0];
    this.companyUuid = e;
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    const capital = this.props.form.getFieldsValue();
    capital.companyName = this.companyName || this.state.content.companyName;
    capital.companyUuid = this.companyUuid || this.state.content.companyUuid;
    delete capital.company;
    this.props.form.validateFields(err => {
      if (!err) {
        handSubmit(capital);
      }
    });
  };

  setCompanyName = (value, option) => {
    this.companyName = option.props.children;
    this.companyUuid = value;
  };

  loadDetail = uuid => {
    queryFundsBookInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          content: res.data,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { permission } = this.props;

    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const { content } = this.state;

    return (
      <Modal title="账户页面" visible onOk={this.submit} onCancel={this.props.cancel}>
        <Form>
          <FormItem label="公司名称" {...formItemLayout}>
            {getFieldDecorator('company', {
              rules: [{ required: true, message: '请输入公司名称' }],
              initialValue: content.companyName,
            })(
              <TreeSelect
                treeData={this.state.treeData}
                loadData={this.onLoadData}
                dropdownStyle={{
                  maxHeight: '500px',
                  overflowY: 'scroll',
                  minHeight: '200px',
                }}
                style={{ width: '100%' }}
                onChange={this.handleCompany}
              />,
            )}
          </FormItem>
          <FormItem label="单位" {...formItemLayout}>
            {getFieldDecorator('unit', {
              initialValue: content.unit,
            })(<Input type="text" />)}
          </FormItem>

          <FormItem label="初始资金" {...formItemLayout}>
            {getFieldDecorator('init', {
              initialValue: content.init || '',
            })(<Input type="number" />)}
          </FormItem>
          <FormItem label="类别" {...formItemLayout}>
            {getFieldDecorator('type', {
              initialValue: content.type || 0,
            })(
              <RadioGroup defaultValue={0} value={content.type}>
                <Radio value={0} disabled={!(permission.all || permission.cash)}>
                  现金帐
                </Radio>
                <Radio value={1} disabled={!(permission.all || permission.stock)}>
                  股票
                </Radio>
                <Radio value={2} disabled={!(permission.all || permission.digitalCurrency)}>
                  数字货币
                </Radio>
              </RadioGroup>,
            )}
          </FormItem>

          <FormItem label="摘要" {...formItemLayout}>
            {getFieldDecorator('remark', {
              initialValue: content.remark,
            })(<Input type="textarea" rows={4} />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(IndexModal);



// WEBPACK FOOTER //
// ./src/components/finance/funds/ModalAdd.js